/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsUserImage,
    SharedserviceMelcoModelsUserImageFromJSON,
    SharedserviceMelcoModelsUserImageFromJSONTyped,
    SharedserviceMelcoModelsUserImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoModelsUserImage
 */
export interface SharedserviceMelcoModelsGenericList1MelcoModelsUserImage {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsUserImage>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsUserImage
     */
    list: Array<SharedserviceMelcoModelsUserImage>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsUserImage
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsUserImage
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsUserImageFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoModelsUserImage {
    return SharedserviceMelcoModelsGenericList1MelcoModelsUserImageFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsUserImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoModelsUserImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoModelsUserImageFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsUserImageToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoModelsUserImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoModelsUserImageToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


